export default __webpack_public_path__ + "static/media/gmhs_logo.783d5922.png";